import React, { useMemo } from 'react'
import {
  TextInput,
  SelectInput,
  required,
  DateInput,
  PasswordInput,
  BooleanInput,
  NumberInput,
} from 'react-admin'
import { isRoleOrganizer } from '../utils'
import { TabbedForm, FormTab } from 'ra-ui-materialui'
import { PhoneInput } from '../../components/custom/PhoneInput'
import { validatePhone } from '../utils/validate'
import { CitiesSelect } from '../../components/custom'
import {
  RolesOptions,
  SportKindsOptions,
  GendersOptions,
  RolesKeyOptions,
} from '../utils/helpers'

const UserForm = (props) => {
  const checkPassword = (value) => {
    if (!value) return 'Введите пароль'
    return undefined
  }
  const checkRepeatPassword = (value, allValues) => {
    if (!value) return 'Повторите пароль'
    if (value !== allValues.plainPassword) {
      return 'Пароли не совпадают!'
    }
    return undefined
  }
  console.log(props)
  const isEditOrganizerRole = useMemo(
    () => isRoleOrganizer(props.record?.roles) && props.isEdit,
    [props]
  )
  return (
    <TabbedForm {...props} label='Редактирования пользователя'>
      <FormTab label='Информация'>
        <TextInput
          fullWidth
          source='firstName'
          label='Имя'
          validate={required()}
        />
        <TextInput
          fullWidth
          source='lastName'
          label='Фамилия'
          validate={required()}
        />
        <SelectInput
          fullWidth
          source='gender'
          label='Пол'
          choices={GendersOptions}
          validate={required()}
        />
        <TextInput
          fullWidth
          source='phone'
          label=''
          validate={[required(), validatePhone]}
          InputProps={{
            inputComponent: PhoneInput,
          }}
        />
        <TextInput
          fullWidth
          type='email'
          source='email'
          label='Email'
          validate={required()}
        />
        <CitiesSelect validate={required()} isEdit={props.isEdit} />
        <DateInput
          source='dateOfBirth'
          label='Дата Рождения'
          fullWidth={true}
        />
        <SelectInput
          fullWidth
          source='sportKind'
          label='Вид спорта'
          choices={SportKindsOptions}
          validate={required()}
        />
        <BooleanInput source='enabled' label='Активен' />
        <BooleanInput source='isEmailConfirmed' label='Email подтверждён' />
        <BooleanInput source='isPhoneConfirmed' label='Телефон подтверждён' />
        <BooleanInput source='isRealEmail' label='Реальный email' />

        {isEditOrganizerRole && (
          <NumberInput
            fullWidth={true}
            source='coin'
            label='Баланс монет'
            format={(value) => (value !== undefined && value !== null ? Number(value) : undefined)}
            parse={(value) =>
              value !== undefined && value !== '' && value !== null ? Number(value) : undefined
            }
          />
        )}
        {props.isEdit && (
          <SelectInput
            fullWidth
            source='roles'
            label='Роль'
            choices={RolesKeyOptions.filter((r) => r.id !== 'ROLE_ADMIN')}
            format={(value) =>
              Array.isArray(value)
                ? value.find((role) => role !== 'ROLE_USER')
                : value
            }
            parse={(value) => (value ? [value, 'ROLE_USER'] : ['ROLE_USER'])}
            validate={required()}
          />
        )}
        {!props.isEdit && (
          <>
            <SelectInput source='role' label='Роль' choices={RolesOptions} />
            <TextInput
              fullWidth
              source='phone'
              label=''
              validate={[required(), validatePhone]}
              InputProps={{
                inputComponent: PhoneInput,
              }}
            />
            <PasswordInput
              fullWidth
              source='plainPassword'
              label='Пароль'
              validate={checkPassword}
              inputProps={{ autocomplete: 'current-plainPassword' }}
            />
            <PasswordInput
              fullWidth
              source='repeatPlainPassword'
              label='Повторите пароль'
              validate={checkRepeatPassword}
              inputProps={{
                autocomplete: 'current-repeatPlainPassword',
              }}
            />
          </>
        )}
      </FormTab>
      {isEditOrganizerRole && (
        <FormTab label='Реквизиты'>
          <TextInput
            fullWidth
            source='organizationDirectorFullName'
            label='ФИО директора'
          />
          <TextInput
            fullWidth
            source='organizationName'
            label='Название организации'
          />
          <TextInput fullWidth source='organizationAddress' label='Адрес' />
          <TextInput fullWidth source='organizationEmail' label='e-mail' />
          <CitiesSelect
            isEdit={props.isEdit}
            source='organizationCity.id'
            label='Город'
          />
          <TextInput fullWidth source='organizationPostalCode' label='Индекс' />
          <TextInput fullWidth source='organizationPhone' label='Телефон' />
        </FormTab>
      )}
    </TabbedForm>
  )
}

export default UserForm
